/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrustDto
 */
export interface TrustDto {
    /**
     * 
     * @type {string}
     * @memberof TrustDto
     */
    thumbPrint?: string;
    /**
     * 
     * @type {string}
     * @memberof TrustDto
     */
    name?: string;
}

export function TrustDtoFromJSON(json: any): TrustDto {
    return TrustDtoFromJSONTyped(json, false);
}

export function TrustDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrustDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'thumbPrint': !exists(json, 'thumbPrint') ? undefined : json['thumbPrint'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TrustDtoToJSON(value?: TrustDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'thumbPrint': value.thumbPrint,
        'name': value.name,
    };
}

